export enum ArticleType {
    Online = "online",
    Action = "action",
    Package ="package",
    Kiosk = "kiosk",
    Other = "other",
}
